import React, { useState } from "react";
import GoogleMapReact from "google-map-react";
import { Modal, Button, Form } from "react-bootstrap";

const MapMarker = ({ lat, lng }) => (
    <div style={{
        width: "32px",
        height: "32px",
        backgroundImage: "url('https://maps.google.com/mapfiles/ms/icons/red-dot.png')",
        backgroundSize: "cover",
        transform: "translate(-50%, -50%)"
    }} />
);


const AddStopModal = ({ show, handleClose, handleAddNewStop, reverseGeocode }) => {
  const [searchText, setSearchText] = useState("");
  const [published, setPublished] = useState(false);
  const [marker, setMarker] = useState(null);
  const [center, setCenter] = useState({ lat: 37.7749, lng: -122.4194 });
  const [geoData, setGeoData] = useState(null);
  
  const handleMapClick = async ({ lat, lng }) => {

    if (!lat || !lng || isNaN(lat) || isNaN(lng)) {
        console.error("Invalid lat/lng received:", lat, lng);
        return;
    }

    setMarker({ lat, lng });
    setCenter({ lat, lng });

    try {
        const geoCodedData = await fetchGeocodeData(lat, lng);
        setGeoData(geoCodedData);
    } catch (error) {
        console.error("Geocoding error:", error);
    }
};


  const handleSearch = async () => {
    if (!searchText) return;

    const apiKey = "AIzaSyCUZiQELkgLvz9RFYDCl4Lsetn3H54jaXI"; // Replace with your API key
    const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(searchText)}&key=${apiKey}`;

    try {
        const response = await fetch(geocodeUrl);
        const data = await response.json();

        if (data.status === "OK") {
            const { lat, lng } = data.results[0].geometry.location;
            const geoCodedData = await fetchGeocodeData(lat, lng);
            setGeoData(geoCodedData);
            setMarker({ lat, lng });
            setCenter({ lat, lng });
        } else {
            alert("Address not found! Please try again.");
        }
    } catch (error) {
        console.error("Geocoding error:", error);
    }
};

const fetchGeocodeData = async (lat, lng) => {

    if (!lat || !lng || isNaN(lat) || isNaN(lng)) {
        console.error("Invalid coordinates for geocoding:", lat, lng);
        return {};  // Return an empty object to avoid undefined errors
    }
    const geocoder = new window.google.maps.Geocoder();
    const latLng = { lat, lng };

    return new Promise((resolve, reject) => {
        geocoder.geocode({ location: latLng }, (results, status) => {
            if (status === window.google.maps.GeocoderStatus.OK && results[0]) {
                const addressComponents = results[0].address_components;
                let city = "";
                let state = "";
                let zip = "";
                let name = "";
                let street = "";

                addressComponents.forEach((component) => {
                    if (component.types.includes("locality")) {
                        city = component.long_name; // City
                    }
                    if (component.types.includes("administrative_area_level_1")) {
                        state = component.short_name; // State
                    }
                    if (component.types.includes("postal_code")) {
                        zip = component.long_name; // ZIP code
                    }
                    if (component.types.includes("route")) {
                        street = component.long_name; // Street Name
                    }
                });

                // Use place name if available, otherwise use the street name
                name = results[0].name || street;

                resolve({
                    city,
                    state,
                    zip,
                    address: results[0].formatted_address,
                    name,
                    street,
                });
            } else {
                reject("Geocode failed due to: " + status);
            }
        });
    });
};



const saveStop = async () => {

    if (!marker || !marker.lat || !marker.lng || isNaN(marker.lat) || isNaN(marker.lng)) {
        alert("Please ensure that a valid stop is selected on the map!");
        return;
    }

    if (!marker) return;

    if (!geoData) {
        console.warn("Geocode data is not available yet. Fetching...");
        try {
            const fetchedGeoData = await fetchGeocodeData(marker.lat, marker.lng);
            setGeoData(fetchedGeoData);
            createStop(fetchedGeoData);
        } catch (error) {
            console.error("Failed to fetch geocode data:", error);
        }
    } else {
        createStop(geoData);
    }
};

// Function to create a new stop object and save it
const createStop = (geo) => {
    const newStop = {
        lat: marker.lat,
        lon: marker.lng,
        name: geo.name || "Unknown", 
        street: geo.street || "Unknown",
        state: geo.state || "",
        zip: geo.zip || "",
        showOnMap: true,
        bPublished: published,
    };

    console.log(newStop);
    handleAddNewStop(newStop);
    handleClose();
};


  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Add Stop</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ height: "400px", width: "100%" }}>
          <GoogleMapReact
            bootstrapURLKeys={{ key: 'AIzaSyCUZiQELkgLvz9RFYDCl4Lsetn3H54jaXI' }}
            center={center}
            defaultZoom={15}
            onClick={handleMapClick}
          >
            {marker && <MapMarker lat={marker.lat} lng={marker.lng} />}
          </GoogleMapReact>
        </div>
        <Form.Group className="mt-3">
          <Form.Label>Search Address</Form.Label>
          <div className="d-flex">
            <Form.Control
              type="text"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Enter address"
            />
            <Button variant="primary" onClick={handleSearch} className="ms-2">
              Search
            </Button>
          </div>
        </Form.Group>
        <Form.Check
          type="checkbox"
          label="Published"
          checked={published}
          onChange={(e) => setPublished(e.target.checked)}
          className="mt-3"
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={saveStop}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddStopModal;